import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './LoanOffer.scss'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import creditDecisionServices from 'services/creditDecisionServices'
import LoanOfferHeader from 'components/application-headers/loan-offer-headers/loan-offer-header/LoanOfferHeader'
import getApplicationServices from 'services/getApplicationServices'
import documentServices from 'services/documentServices'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import AppContext from 'contexts/AppContext'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'
import Calculator from './Calculator/Calculator'
import { LoanOfferConfirmationModal } from 'components/modals/loanoffer-confirmation-modal/LoanOfferConfirmationModal'
import pnServices from 'services/pnServices'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'

const LoanOfferDe = () => {
	const { t } = useTranslation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext,
	)
	const { setHeader } = useContext(AppContext)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [loading, setLoading] = useState<boolean>(true)
	const [error, setError] = useState<Error | any>()
	const [disabled, setDisabled] = useState<boolean>(true)
	const [showConfirmationModal, setShowConfirmationModal] =
		useState<boolean>(false)
	const applicationId = loanApplication.applicationData?.loanNumber!

	useEffect(() => {
		getApplicationInformation(applicationId)
	}, []) //eslint-disable-line

	const updateLoanData = async () => {
		setLoading(true)
		try {
			await creditDecisionServices
				.updateLoanData(
					applicationId,
					{
						amount: loanApplication.updateApplicationData?.loanData
							?.amount!,
						repaymentPeriod:
							loanApplication.updateApplicationData?.loanData
								?.repaymentPeriod!,
					},
					t,
				)
				.then(async (response) => {
					if (response?.status === 200) {
						await pnServices.printPn(applicationId, t)
						await getApplicationInformation(applicationId).then(
							() => {
								setHeader(<LoanOfferHeader />)
								dispatchMsp({
									type: MSP_ACTIONS.SET_INDEX,
									payload: {
										index: msp.index + 1,
									},
								})
							},
						)
					}
				})
		} catch (error) {
			console.warn(error)
			setError(error)
			setLoading(false)
		}
	}

	const getApplicationInformation = async (applicationId: number) => {
		setLoading(true)
		try {
			await getApplicationServices
				.GetApplicationInformation(applicationId, t)
				.then((response) => {
					loanApplication.setApplicationData(response)
				})
			await documentServices
				.getDownloadDocuments(applicationId.toString(), t)
				.then((response) => {
					loanApplication.setDocumentData(response)
				})
		} catch (error) {
			console.warn(error)
			setError(error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (
			loanApplication.applicationData?.lifeCycleStatus ===
				LifeCycleStatus.CreditDecisionError ||
			loanApplication.applicationData?.lifeCycleStatus ===
				LifeCycleStatus.CreditDecisionInvestigation
		) {
			dispatchMsp({
				type: MSP_ACTIONS.RESET_STEPS,
			})
		}
	}, [loanApplication.applicationData?.lifeCycleStatus]) //eslint-disable-line

	useEffect(() => {
		setDisabled(
			loanApplication.updateApplicationData?.loanData
				?.maxInstalmentWarning ?? true,
		)
	}, [loanApplication.updateApplicationData?.loanData])

	return (
		<div className="loan-offer">
			{loading ? (
				<div className="col-spinner">
					<CircleSpinner />
				</div>
			) : (
				<>
					{loanApplication.applicationData?.offer === undefined ? (
						<ErrorBox message={`${t('LoanInfoError')}`} />
					) : (
						<>
							{showConfirmationModal && (
								<LoanOfferConfirmationModal
									showModal={true}
									handleCancel={() => {
										setShowConfirmationModal(false)
									}}
									handleContinue={() => {
										setShowConfirmationModal(false)
										updateLoanData()
									}}
								/>
							)}
							<Calculator />
							{error ? (
								<ErrorBox message={t('ErrorMsg')} />
							) : null}
							<div className="loan-offer-next-button">
								<button
									id="loan-offer-next-button"
									className="btn btn-primary"
									disabled={disabled}
									onClick={() => {
										setTimeout(() => {
											setShowConfirmationModal(true)
										}, 400)
									}}>
									{t('Next')}
								</button>
							</div>
						</>
					)}
				</>
			)}
		</div>
	)
}

export default LoanOfferDe
